import React, { FC } from 'react';

import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';

import Image, { ImageProps } from '../image/image';

const StyledCardImage: FC<ImageProps> = styled(Image)({
  label: 'cardImage',
  flex: '1 1 100%'
});

const CardImageWrapper: FC<ImageProps> = ({ className, ...rest }) => (
  <StyledCardImage {...rest} className={className} />
);

const CardImage = withTheme(CardImageWrapper);

export { CardImage };
export default CardImage;
